<template>
  <div class="product-banner" :style="`background: url('${banner}')`">
    <div class="product-slogan">
      <img :src="icon" alt="">
      {{title}}
    </div>
    <div class="product-slogan-description">{{description}}</div>
  </div>
</template>

<script>
export default {
  props: {
    banner: String,
    title: String,
    description: String,
    icon: String
  }
}
</script>

<style lang="less" scoped>
  .product-banner{
    width: 100%;
    height: 25.833vw;
    background-size: 100% 100%;
    background-position: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #fff;
    .product-slogan{
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 0.521vw;
      margin-top: 5.208vw;
      font-size: 1.563vw;
      font-weight: 600;
      text-align: center;
      img{
        width: 1.667vw;
        height: 1.667vw;
      }
    }
    .product-slogan-description{
      max-width: 72.708vw;
      margin: 1.563vw auto 0;
      font-size: 0.938vw;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/productBanner.vue